import { map, distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Input, Directive, forwardRef } from '@angular/core';
import { AsyncValidator, AbstractControl, NG_ASYNC_VALIDATORS } from '@angular/forms';
import { TenantService } from '../services/tenant.service';

@Directive({
    selector: '[validateUniqueDomain]',
    providers: [
        { provide: NG_ASYNC_VALIDATORS, useExisting: forwardRef(() => UniqueDomainValidator), multi: true }
    ]
})
export class UniqueDomainValidator implements AsyncValidator {
    @Input() originalDomain; 

    constructor(private tenantService: TenantService) {}
                        
    validate(control: AbstractControl): Observable<{ [key: string]: any }> {
        return this.tenantService.tenantHostExists(control.value + '.attensa.net')
        .pipe(
            debounceTime(250),
            distinctUntilChanged(),
            map(response => 
                response.exists && this.originalDomain !== control.value ? { uniqueDomain: true } : undefined)
        );
    }
}
